import { Box, FormControl, FormLabel, Text, VisuallyHidden, forwardRef } from '@chakra-ui/react';

import { LabelPosition } from '../FormWidget.types';
import { InputBaseProps } from './InputBase.types';

export const InputBase = forwardRef<InputBaseProps, 'label'>(
  (
    {
      id,
      label,
      formType,
      containerProps,
      fontSize,
      labelStyles,
      labelPosition,
      isLabelFocused,
      isReadOnly,
      onLabelClick,
      onLabelTextClick,
      children,
    },
    ref,
  ) => {
    const isHorizontal = labelPosition === LabelPosition.Left;
    const isLongQuestion = id.indexOf('longQuestion') !== -1;
    const { alignSelf, textAlign, gap, minWidth, ...restStyles } = labelStyles;

    return (
      <Box id={id} padding='1' {...containerProps} minWidth='min-content'>
        <FormControl
          {...(isHorizontal
            ? { display: 'flex', alignItems: 'center', gap: `${gap}px` }
            : { display: 'flex', flexDirection: 'column', gap: `${gap}px` })}
        >
          {label ? (
            <FormLabel
              ref={ref}
              fontSize={`${fontSize}px`}
              style={{
                ...restStyles,
                ...(isHorizontal ? { alignSelf } : { textAlign }),
                ...(isLongQuestion && !isHorizontal ? { minWidth } : {}),
              }}
              onClick={onLabelClick}
              m={0}
              cursor='move'
              width={isHorizontal ? '50%' : '100%'}
            >
              <Text
                as={isReadOnly ? 'p' : 'span'} // PDF export requires <p> for pdf a11y, but <span> for web a11y
                display='inline-block'
                maxWidth='100%'
                textDecoration='inherit'
                onClick={onLabelTextClick}
                boxShadow={isLabelFocused ? '0 0 0 1px var(--vg-colors-upgrade-blue-500)' : 'none'}
                cursor='pointer'
              >
                {label}
              </Text>
            </FormLabel>
          ) : (
            /* Render visually hidden label for pdf a11y */
            <VisuallyHidden as='label' overflow={'unset'} sx={{ clip: 'unset' }}>
              <p>{`${formType} form`}</p>
            </VisuallyHidden>
          )}
          {children}
        </FormControl>
      </Box>
    );
  },
);
